import React, { useState } from "react";
import { Table } from "antd";
import { CONSUMPTION_TYPE } from "@/constants/util";

const Content = (props) => {
  const {
    dataSource,
    page,
    onTableChange = () => {},
    onShowSizeChange = () => {},
  } = props;

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const columns = [
    {
      title: "时间",
      dataIndex: "createTime",
      key: "createTime",
    },
    {
      title: "运营商",
      dataIndex: "operateCompanyName",
      key: "operateCompanyName",
    },
    {
      title: "投放点位",
      dataIndex: "pointName",
      key: "pointName",
    },
    {
      title: "消费类型",
      dataIndex: "mode",
      key: "mode",
      render: (text) => CONSUMPTION_TYPE[text],
    },
    {
      title: "消费金额/元",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "账户余额/元",
      dataIndex: "balance",
      key: "balance",
    },
  ];

  return (
    <div className="bg-white pt-16 pl-24 pr-24">
      <Table
        rowSelection={null}
        dataSource={dataSource}
        rowKey="companyId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      />
    </div>
  );
};

export default Content;
